import { create } from "zustand";
import { persist } from "zustand/middleware";
import { STORAGE_KEYS } from "@/config/constants";
import { prefsChannel } from "@/lib/broadcast";

export type Theme = "light" | "dark" | "system";
export type Language = "zh-CN" | "en-US";

export interface PreferencesState {
  theme: Theme;
  language: Language;
}

export interface PreferencesActions {
  set: (patch: Partial<PreferencesState>) => void;
  reset: () => void;
  applyFromServer: (patch: Partial<PreferencesState>) => void;
}

const DEFAULT_PREFERENCES: PreferencesState = {
  theme: "system",
  language: "zh-CN",
};

export const usePreferencesStore = create<PreferencesState & PreferencesActions>()(
  persist(
    (set) => ({
      ...DEFAULT_PREFERENCES,
      set: (patch) => {
        set(patch);
        prefsChannel.post({ type: "prefs-updated", patch });
      },
      reset: () => set(DEFAULT_PREFERENCES),
      applyFromServer: (patch) => set(patch),
    }),
    {
      name: STORAGE_KEYS.PREFERENCES,
      partialize: (state) => {
        const { set: _set, reset: _reset, applyFromServer: _asf, ...persisted } = state;
        return persisted;
      },
    },
  ),
);

// 订阅广播：同步其他 Tab 的偏好变更
prefsChannel.subscribe((msg) => {
  if (msg.type === "prefs-updated") {
    usePreferencesStore.setState(msg.patch);
  }
});
